import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  filteredHotelsSelector,
  selectedHotelSelector,
} from '../../layouts/property/propertySlice';
import './Expand-Menu-List.scss';
import { Icon } from '@mui/material';
import {
  RBAC_PERMISSION_LEVEL_API_READ_ONLY,
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
} from '../../constants/RoleConsts';

const ExpandMenuList = (props) => {
  const history = useHistory();
  const { menuItem, menuExpanded, permissions, isDisableMenu = false } = props;
  const [isExpand, setExpand] = useState(false);
  const area = window.location.pathname.split('/')[1];
  const selectedHotel = useSelector(selectedHotelSelector);
  const filteredHotelList = useSelector(filteredHotelsSelector);
  const redirectTo = (link) => {
    if (window.location.pathname !== link) {
      history.push(link);
    }
  };
  // implemented a method as the Restriction logic will grow as the project proceeds
  const onRestrictedCheck = (menuItem) => {
    return (
      isDisableMenu ||
      ((menuItem.title === 'Hotel' ||
        menuItem.title === 'Configurations' ||
        menuItem.title === 'Services' ||
        menuItem.title === 'Campaign' ||
        menuItem.title === 'CMS') &&
        !selectedHotel)
    );
  };

  useEffect(() => {
    setExpand(menuItem.children.some((item) => item.route.split('/')[1] === area));
  }, [area, menuItem]);

  const checkAccessLevel = (accessTypes) => {
    for (const permission in permissions) {
      if (
        accessTypes?.some((val) => val === permission) &&
        permissions[permission] > RBAC_PERMISSION_LEVEL_NO_ACCESS &&
        permissions[permission] < RBAC_PERMISSION_LEVEL_API_READ_ONLY
      ) {
        return true;
      }
    }
    return false;
  };

  const checkHotelLevelAccess = (menuItem) => {
    if (!menuItem.checkHotelAccess) {
      return true;
    } else {
      if (selectedHotel && menuItem.hotelCheckField) {
        const selectedHotelDetails = filteredHotelList.find((hotel) => hotel.id === selectedHotel);
        return selectedHotelDetails && selectedHotelDetails[menuItem.hotelCheckField];
      } else {
        return false;
      }
    }
  };

  return (
    <div
      key={menuItem.title}
      className={`${onRestrictedCheck(menuItem) ? 'disable-item' : ''}`}
      title={menuItem.title}
    >
      <div
        className={`${
          menuItem.children.some((item) => item.route.split('/')[1] === area)
            ? 'left-bar-menu-item-selected'
            : 'left-bar-menu-item'
        } d-flex justify-content-between showpopup`}
        title={menuItem.title}
        key={menuItem.title}
        onClick={(e) => {
          setExpand(!isExpand);
        }}
      >
        <div className='d-flex align-items-center'>
          <Icon className='showpopup' fontSize='small'>
            {menuItem.icon}
          </Icon>
          {menuExpanded && <span className='menu-item-title showpopup'>{menuItem.title}</span>}
        </div>
        {menuExpanded && <i className={`fa ${isExpand ? 'fa-angle-down' : 'fa-angle-right'}`}></i>}
      </div>
      {isExpand && (
        <div
          className={`${
            menuExpanded ? 'expanded-menu-list-container' : 'colapsed-menu-list-container'
          }`}
        >
          {menuItem.children.map((item, key) => (
            <div key={key}>
              {checkAccessLevel(item.permission) && checkHotelLevelAccess(item) && (
                <div
                  className={`${
                    item.route.split('/')[1] === area
                      ? 'secondary-menu-item-selected'
                      : 'secondary-menu-item'
                  } d-flex showpopup`}
                  onClick={(e) => {
                    redirectTo(item.route);
                  }}
                  title={item.title}
                >
                  <Icon className='showpopup' fontSize='small'>
                    {item.icon}
                  </Icon>
                  {menuExpanded && (
                    <span className='secondary-menu-item-title showpopup'>{item.title}</span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExpandMenuList;
